<template>
  <div class="error">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMessage'
  };
</script>

<style scoped>
    .error {
        border: 1px solid darkred;
        background: rgba(139, 0, 0, 0.1);
        line-height: 1.5em;
        padding: 0.5em 1em;
        border-radius: 5px;
        color: darkred;
    }
</style>
